import { ToggleField } from 'lib/iterable-hook-form';
import styled from 'styled-components';
import { ClickTip } from 'ui/popover';
import { body2, caption, colors, fontWeights, spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';
import { pxToRem } from 'utils/convert';

export const PublishedJourneyOptionsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${spacing.threeQuarter};
`;

export const PublishedJourneyTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
  margin-bottom: ${spacing.quarter};
`;

export const SwitchLabel = styled.div`
  ${body2}
`;

export const StyledToggleField = styled(ToggleField)`
  margin-top: ${spacing.quarter};
`;

export const VisitorTrackingWarning = styled.div`
  border-radius: ${spacing.quarter};
  background: ${colors.backgroundSecondary};
  padding: ${spacing.half};
`;

export const VisitorTrackingBodyBold = styled(Tooltip)`
  font-weight: ${fontWeights.bold};
  border-bottom: 1px dashed ${colors.borderEmphasis};
`;

export const VistorTrackingBodyPrimary = styled.p`
  ${caption}
  margin-bottom: ${spacing.half};
`;

export const VistorTrackingBodySecondary = styled.p`
  ${caption}
  color: ${colors.textSecondary};
`;

export const PopoverContentWrapper = styled.div`
  > div {
    padding: ${spacing.base};

    &:nth-child(2) {
      border-top: 1px solid ${colors.borderPrimary};
    }
  }
`;

export const StyledClickTip = styled(ClickTip)`
  max-width: ${pxToRem(248)};
  && > div {
    padding: 0;

    > div {
      padding: 0;
    }
  }
`;

export const StyledLoadingInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;
